/* @flow */

function percentageChange(curr: number, prev: number, decPlaces?: number): number {
  if (prev === 0)
    return (curr === 0 ? 0.0 : 100.0);
  let r: number = ((100.0 / prev) * curr) - 100;
  if (typeof decPlaces !== 'undefined') {
    let f: number = r.toFixed(decPlaces);
    r = parseFloat(f);
  }
  return r;
}

export default percentageChange;



// WEBPACK FOOTER //
// ./src/utils/percentage-change.js